import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {
  FilterSubService,
  ResponseSubService,
  SubService,
  SubServiceInitState
} from '@/store/subservice/subservice.types';
import {SubServiceEnumApi} from '@/store/subservice/subservice.enum';


export const SubServiceAction: ActionTree<SubServiceInitState, RootState> = {
  async _getSubService(req: ActionContext<SubServiceInitState, RootState>, filter?: FilterSubService): Promise<void> {
    let {commit} = req;
    try {

      let subService = await HttpService.get(SubServiceEnumApi.SubService, filter) as { data: ResponseSubService };
      if (subService.data.appCode === 20000) {
        commit('mutationGetSubService', subService.data.data);
      } else {
        commit('mutationGetSubService', []);
      }
    } catch (e) {
      commit('mutationGetSubService', []);
      console.error('DEBUG: _getSubService ', e.message);
    }
  },
  async _deleteSubService(req: ActionContext<SubServiceInitState, RootState>, payload: string): Promise<void> {
    try {
      let res = await HttpService.delete(SubServiceEnumApi.SubService, payload);
      return res;
    } catch (e) {
      console.error('DEBUG: _deleteSubService ', e.message);
    }
  }
  // async _insertCommunity(req: ActionContext<CommunityInitState, RootState>, payload: Community): Promise<void> {
  //   try {
  //     let {dispatch} = req;
  //     let res = await HttpService.post(CommunityEnumApi.community, payload);
  //     await dispatch('_getCommunity');
  //     return res;
  //   } catch (e) {
  //     console.error('DEBUG: _insertCommunity ', e.message);
  //   }
  // },
  // async _updateCommunity(req: ActionContext<CommunityInitState, RootState>, payload: Community): Promise<void> {
  //   try {
  //     let {dispatch} = req;
  //     let res = await HttpService.put(CommunityEnumApi.community, payload);
  //     await dispatch('_getCommunity');
  //     return res;
  //   } catch (e) {
  //     console.error('DEBUG: _updateCommunity ', e.message);
  //   }
  // },

};
